import { useQuery } from "@tanstack/react-query";
import { getAllIntegrations } from "../actions/getAllIntegrations.action";
import { AppConfig } from "../interfaces/appIntegration.interfaces";


export const useGetAllIntegrations = () => {
    const { data: integrations, isLoading, error } = useQuery<AppConfig[]>({
        queryKey: ["integrations"],
        queryFn: getAllIntegrations,
    });

    return { integrations: integrations || [], isLoading, error };
};